import { LONG_TRANSIT_TIME } from '../helpers/stopoverConstants';

const getTransitType = duration =>
  duration >= LONG_TRANSIT_TIME
    ? I18n.t('components.flight.transit.long')
    : I18n.t('components.flight.transit.short');

export default getTransitType;
